'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const CalendarGridRootContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridRootContext.displayName = "CalendarGridRootContext";
export function useCalendarGridRootContext() {
  const context = React.useContext(CalendarGridRootContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: `CalendarGridRootContext` is missing. CalendarGrid parts must be placed within <CalendarGrid.Root />.' : _formatErrorMessage(218));
  }
  return context;
}